<template>
  <div class="pratio">
    <h4 class="pratio__h">A normal photograph takes <span class="pratio__accent">a 250th of a second</span>. His take half a year.</h4>
    <div class="pratio__grid">
      <div class="pratio__card">
        <div class="pratio__lab">Normal photograph</div>
        <div class="pratio__num">0.004 s</div>
        <div class="pratio__sub">1 / 250 of a second</div>
      </div>
      <div class="pratio__vs">×</div>
      <div class="pratio__card pratio__card--accent">
        <div class="pratio__lab">His six-month heliograph</div>
        <div class="pratio__num">15,800,000 s</div>
        <div class="pratio__sub">183 days, continuous exposure</div>
      </div>
    </div>
    <div class="pratio__final">
      <div class="pratio__final-num">≈ 4 billion×</div>
      <div class="pratio__final-txt">
        Stroobant's exposures are roughly <strong>3,950,000,000 times longer</strong> than a normal photograph. The reason a bar chart of this can't honestly be drawn is that 1/250 second is invisible at any scale that fits six months on the page.
      </div>
    </div>
  </div>
</template>

<style scoped>
.pratio {
  margin: 1.6rem 0;
  padding: 1.6rem 1.8rem;
  background: rgba(168,132,69,0.06);
  border: 1px solid var(--vein);
  border-radius: 4px;
}
.pratio__h {
  font-family: var(--font-body);
  font-size: clamp(1.6rem, 2.4vw, 2.25rem);
  font-weight: 500;
  line-height: 1.11;
  margin: 0 0 1.4rem;
  max-width: 28ch;
  color: #000;
  letter-spacing: 0;
}
.pratio__accent { color: var(--accent-cursive); }
.pratio__grid {
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  gap: 1.4rem;
  align-items: center;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid var(--vein);
}
.pratio__card {
  padding: 1.1rem 1.3rem;
  background: rgba(255,255,255,0.55);
  border-radius: 4px;
}
.pratio__card--accent { background: var(--accent-cursive); color: var(--paper); }
.pratio__lab {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #000;
  font-weight: 400;
  line-height: 1.14;
}
.pratio__card--accent .pratio__lab { color: #F6F1E9; }
.pratio__num {
  font-family: var(--font-body);
  font-size: clamp(2rem, 3.4vw, 2.75rem);
  font-weight: 500;
  margin: 0.5rem 0 0.3rem;
  color: #000;
  letter-spacing: 0;
  line-height: 1;
}
.pratio__card--accent .pratio__num { color: #F6F1E9; }
.pratio__sub {
  font-family: var(--font-body);
  font-size: clamp(1rem, 1.4vw, 1.4rem);
  line-height: 1.33;
  color: #000;
  font-weight: 400;
}
.pratio__card--accent .pratio__sub { color: #F6F1E9; }
.pratio__vs {
  text-align: center;
  font-family: var(--font-body);
  font-size: 1.6rem;
  color: var(--granite-soft);
  font-weight: 400;
}

.pratio__final {
  margin-top: 1.4rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1.6rem;
  align-items: baseline;
}
.pratio__final-num {
  font-family: var(--font-body);
  font-size: clamp(2.2rem, 3.4vw, 2.75rem);
  font-weight: 500;
  color: var(--accent-cursive);
  line-height: 1;
  letter-spacing: 0;
}
.pratio__final-txt {
  font-family: var(--font-body);
  font-size: clamp(1.1rem, 1.45vw, 1.4rem);
  line-height: 1.33;
  color: #000;
  font-weight: 400;
}
.pratio__final-txt strong { color: #000; font-weight: 700; }

@media (max-width: 760px) {
  .pratio__grid { grid-template-columns: 1fr; }
  .pratio__vs { transform: rotate(90deg); }
  .pratio__final { grid-template-columns: 1fr; }
}
</style>
